<template>
  <div>
    <!-- <vs-tabs v-model="tabIndex" class="unique_cstm_tab cstm_line_tabular_view"> -->
      <!-- <vs-tab label="Overview"> -->
        <SummaryComponent v-model="maximizeCard" :module_id="55"></SummaryComponent>

        <div class="flex flex-wrap mb-4">
          <div class="lg:w-full w-full p-2">
            <vs-card class="content_mb_0 mb-0 h-full">
              <div slot="header">
                <h4>Upcoming Lessons</h4>
              </div>
              <LessonTab />
            </vs-card>
          </div>
          <!-- <div class="lg:w-1/2 w-full p-2">
            <vs-card class="content_mb_0 mb-0 h-full">
              <div slot="header">
                <h4>Room Utilisation</h4>
              </div>
              <div
                style="max-height: 350px; overflow: auto"
                class="
                  table-responsive
                  cstm_vuexy_table
                  border_table
                  gantt_room_table
                  vertical_scrollbar
                  horizontal_scrollbar
                "
              >
                <table v-if="loaded">
                  <thead>
                    <tr>
                      <th
                        style="min-width: 180px; max-width: 180px; z-index: 11"
                      ></th>
                      <th>10:00</th>
                      <th>11:00</th>
                      <th>12:00</th>
                      <th>13:00</th>
                      <th>14:00</th>
                      <th>15:00</th>
                      <th>16:00</th>
                      <th>17:00</th>
                      <th>18:00</th>
                      <th>19:00</th>
                      <th>20:00</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(eachRoom, index) in rooms"
                      :key="index"
                      class="relative"
                    >
                      <td>
                        <div class="inline-flex items-center w-full">
                          <img
                            style="
                              width: 54px;
                              height: 38px;
                              object-fit: contain;
                            "
                            :src="eachRoom.image"
                            alt="room"
                          />
                          <span style="max-width: calc(100% - 54px);" class="one_line_truncate pl-2">{{ eachRoom.label }}</span>
                        </div>
                      </td>
                      <td v-for="i in 11" :key="i.id"></td>

                      <div
                        class="parent"
                        :style="`grid-template-columns: repeat(${gridCount}, 1fr);`"
                      >
                        <div
                          class="items"
                          :style="`grid-column-start: ${getTimePosition(
                            eachSlot.start_time
                          )}; grid-column-end: ${getTimePosition(
                            eachSlot.end_time
                          )}; background: ${eachSlot.color}`"
                          v-for="(eachSlot, index1) in eachRoom.slots"
                          :key="index1"
                        >
                          <vs-tooltip
                            color="primary"
                            :text="`${eachSlot.start_time} - ${eachSlot.end_time} - ${eachSlot.label}`"
                            position="top"
                          >
                            <label style="max-width: 90%;" class="one_line_truncate">{{ eachSlot.label }}</label>
                          </vs-tooltip>
                        </div>
                      </div>
                    </tr>
                  </tbody>
                </table>
              </div>
            </vs-card>
          </div> -->
        </div>

        <div class="flex flex-wrap mb-4">
          <div class="xl:w-1/4 lg:w-1/2 p-2 w-full h-full">
            <vs-card class="content_mb_0 mb-0">
              <div class="flex items-center border_btm pb-4">
                <span class="material-icons-outlined">check_box</span>
                <h5 class="pl-2">Quick Task</h5>
              </div>
              <Task />
            </vs-card>
          </div>

          <div class="xl:w-1/4 lg:w-1/2 p-2 w-full h-full">
            <vs-card class="content_mb_0 mb-0">
              <div class="flex items-center border_btm pb-4">
                <span class="material-icons-outlined">email</span>
                <h5 class="pl-2">Quick Message/Email</h5>
              </div>
              <QuickTab />
            </vs-card>
          </div>

          <div class="xl:w-1/4 lg:w-1/2 p-2 w-full h-full">
            <vs-card class="content_mb_0 mb-0">
              <div class="flex items-center border_btm pb-4">
                <span class="material-icons-outlined">folder_special</span>
                <h5 class="pl-2">Recent files</h5>
              </div>
                <RecentFiles />
            </vs-card>
          </div>

          <div class="xl:w-1/4 lg:w-1/2 p-2 w-full h-full">
            <vs-card class="content_mb_0 mb-0">
              <div class="flex items-center border_btm pb-4">
                <span class="material-icons-outlined">fact_check</span>
                <h5 class="pl-2">Feed (posts)</h5>
              </div>
                <FeedPost />
            </vs-card>
          </div>
        </div>

        <vs-card class="content_mb_0 mb-0">
          <div slot="header">
            <h4>Teacher Attendance</h4>
          </div>
          <TeacherAttendance />
        </vs-card>
      <!-- </vs-tab> -->
      <!-- <vs-tab label="Statistics"> </vs-tab> -->
    <!-- </vs-tabs> -->
  </div>
</template>

<script>

import LessonTab from '@/views/pages/v1/Admin/lessonsTab.vue'
import Task from '@/views/pages/v1/Admin/taskDashboard.vue'
import RecentFiles from '@/views/pages/v1/Admin/recentFiles.vue'
import FeedPost from '@/views/pages/v1/Admin/feedPost.vue'
import TeacherAttendance from '@/views/pages/v1/Admin/teacherAttendance.vue'
import SummaryComponent from '@/views/pages/analytics/summeryLIst'
import QuickTab from '@/views/pages/v1/Teacher/quickTab.vue'


export default {
  components: {
    RecentFiles,
    FeedPost,
    TeacherAttendance,
    Task,
    SummaryComponent,
    LessonTab,
    QuickTab
  },
  data () {
    return {
      maximizeCard: true,
      timesMap: {},
      loaded: false,
      gridCount: 0,
      rooms: [
        {
          label: 'Room 1',
          image:
            'https://scoolio-files.s3.ap-south-1.amazonaws.com/20211129063744097501/Default/f3zvbwSRndgUyEbA.jpg',
          slots: [
            {
              label: 'Piano Learner for beginner crash course',
              start_time: '10:15',
              end_time: '13:00',
              color: '#6FAD15'
            },
            {
              label: 'Off',
              start_time: '14:01',
              end_time: '14:30',
              color: '#F14848'
            },
            {
              label: 'Piano 2',
              start_time: '18:00',
              end_time: '20:00',
              color: '#6FAD15'
            }
          ]
        },
        {
          label: 'Room 2',
          image:
            'https://scoolio-files.s3.ap-south-1.amazonaws.com/20211129063744097501/Default/f3zvbwSRndgUyEbA.jpg',
          slots: [
            {
              label: 'Piano 1',
              start_time: '11:00',
              end_time: '14:00',
              color: '#6FAD15'
            },
            {
              label: 'Off',
              start_time: '16:00',
              end_time: '17:00',
              color: '#F14848'
            }
          ]
        },
        {
          label: 'Room 3',
          image:
            'https://scoolio-files.s3.ap-south-1.amazonaws.com/20211129063744097501/Default/f3zvbwSRndgUyEbA.jpg',
          slots: [
            {
              label: 'Piano 1',
              start_time: '10:00',
              end_time: '12:00',
              color: '#6FAD15'
            },
            {
              label: 'Off',
              start_time: '15:00',
              end_time: '16:00',
              color: '#F14848'
            },
            {
              label: 'Piano 2',
              start_time: '18:00',
              end_time: '19:00',
              color: '#6FAD15'
            }
          ]
        },
        {
          label: 'Room 4',
          image:
            'https://scoolio-files.s3.ap-south-1.amazonaws.com/20211129063744097501/Default/f3zvbwSRndgUyEbA.jpg',
          slots: [
            {
              label: 'Piano 1',
              start_time: '11:00',
              end_time: '14:00',
              color: '#6FAD15'
            },
            {
              label: 'Off',
              start_time: '17:00',
              end_time: '18:00',
              color: '#F14848'
            }
          ]
        },
        {
          label: 'Room 5',
          image:
            'https://scoolio-files.s3.ap-south-1.amazonaws.com/20211129063744097501/Default/f3zvbwSRndgUyEbA.jpg',
          slots: [
            {
              label: 'Piano 1',
              start_time: '10:15',
              end_time: '13:00',
              color: '#6FAD15'
            },
            {
              label: 'Off',
              start_time: '14:01',
              end_time: '15:00',
              color: '#F14848'
            },
            {
              label: 'Piano 2',
              start_time: '18:00',
              end_time: '20:00',
              color: '#6FAD15'
            }
          ]
        }
      ]
    }
  },
  mounted () {
    this.generateTimeBlock()
  },
  methods: {
    getTimePosition (time) {
      return this.timesMap[time]
    },
    generateTimeBlock () {
      let counter = 0
      const object = {}
      for (let i = 10; i <= 20; i++) {
        for (let j = 0; j < 60; j++) {
          if (j > 9) {
            object[`${i}:${j}`] = ++counter
          } else {
            object[`${i}:0${j}`] = ++counter
          }
        }
      }
      this.gridCount = counter
      this.timesMap = object
      this.loaded = true
    }
  }
}
</script>

<style>
.parent {
  display: grid;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  position: absolute;
  left: 180px;
  width: calc(100% - 180px);
  top: 50%;
  transform: translateY(-50%);
}
.items {
  width: 100%;
  height: 100%;
  padding: 5px;
  border-radius: 3px;
  color: #fff;
}
</style>
